/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const PRESET_SIZES = {
  XX_LARGE: 'xxlarge',
  X_LARGE: 'xlarge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  X_SMALL: 'xsmall',
  XX_SMALL: 'xxsmall',
  XXX_SMALL: 'xxxsmall',
};

export const TEXT_SIZES = [
  PRESET_SIZES.X_LARGE,
  PRESET_SIZES.LARGE,
  PRESET_SIZES.MEDIUM,
  PRESET_SIZES.SMALL,
  PRESET_SIZES.X_SMALL,
];

export const DISPLAY_SIZES = [
  PRESET_SIZES.LARGE,
  PRESET_SIZES.MEDIUM,
  PRESET_SIZES.SMALL,
];

export const HEADLINE_SIZES = [
  PRESET_SIZES.XX_LARGE,
  PRESET_SIZES.X_LARGE,
  PRESET_SIZES.LARGE,
  PRESET_SIZES.MEDIUM,
  PRESET_SIZES.SMALL,
  PRESET_SIZES.X_SMALL,
  PRESET_SIZES.XX_SMALL,
  PRESET_SIZES.XXX_SMALL,
];
